import Cookies from 'js-cookie';
import AppConstants from '../constants/appConstants';
import { logoutUser } from './notification';

const cookies = ['__hssc', '__hssrc', '__hstc', 'hs-messages-is-open', 'hubspotutk', 'messagesUtk'];

const cookiesRemove = name => Cookies.remove(name, { path: '', domain: AppConstants.DOMAIN_APP });

export const handleLogout = async (callback = async () => {}) => {
  await callback();

  localStorage.removeItem('user-identified');
  localStorage.setItem('showVerifyModal', 'true');
  cookies.forEach(item => cookiesRemove(item));

  await window.HubSpotConversations.clear({ resetWidget: true });

  logoutUser();
};
